@if (!useIcon() && everythingOk) {
  <ng-container miqStopClick>
    <a
      [target]="target()"
      [class]="classes()"
      [matTooltipDisabled]="!toolTipMessage()"
      [matTooltip]="toolTipMessage()"
      [routerLink]="internalParams"
      miqStopClick
      >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </ng-container>
}

@if (useIcon() === true && everythingOk) {
  <ng-container miqStopClick>
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <a
      [target]="target()"
      [class]="classes()"
      [matTooltipDisabled]="!toolTipMessage()"
      [matTooltip]="toolTipMessage()"
      [routerLink]="internalParams"
      [queryParams]="dataParams()"
      miqStopClick
      >
      <mat-icon class="icon" [svgIcon]="svgIconName()"></mat-icon>
    </a>
  </ng-container>
}

@if (everythingOk === false) {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content><ng-content></ng-content></ng-template>
